export function shiftSelectClick (list, currentSelection, lastSelectedIndex, clickedItem, event) {
  const clickedIndex = list.indexOf(clickedItem)
  if (clickedIndex === -1) return { selection: null, anchor: lastSelectedIndex }

  if (!event.shiftKey || lastSelectedIndex === null) {
    return { selection: null, anchor: clickedIndex }
  }

  event.stopPropagation()

  const start = Math.min(lastSelectedIndex, clickedIndex)
  const end = Math.max(lastSelectedIndex, clickedIndex)
  const rangeItems = list.slice(start, end + 1)
  const rangeSet = new Set(rangeItems)
  const outsideRange = currentSelection.filter(s => !rangeSet.has(s))

  return { selection: [...outsideRange, ...rangeItems], anchor: lastSelectedIndex }
}
